import { Box, Button, Typography } from '@mui/material';
import { useState } from 'react';

import trimText from './../../assets/utils/trimText';

interface DetailsProps {
  details: string | null;
}

const Details = ({ details }: DetailsProps) => {
  const [showOriginal, setShowOriginal] = useState(false);
  const originalHTML = details ?? '';
  const trimmedHTML = details ? trimText(details, 20, 200, 300)[0] : '';

  const toggleExpand = () => {
    setShowOriginal((value) => !value);
  };

  return (
    <Box sx={{ mb: 2.2 }}>
      <Typography
        sx={{
          fontFamily: 'Schibsted Grotesk',
          fontSize: '14px',
          fontWeight: 500,
          lineHeight: '17px',
          letterSpacing: '0em',
          textAign: 'left',
          mb: 1,
          mt: 2.25,
          color: '#000000',
        }}
      >
        Details
      </Typography>
      <div
        dangerouslySetInnerHTML={{
          __html: showOriginal ? originalHTML : trimmedHTML,
        }}
      ></div>
      {originalHTML && trimmedHTML && originalHTML !== trimmedHTML && (
        <Button
          variant='text'
          onClick={toggleExpand}
          sx={{
            textTransform: 'none',
            color: 'black',
          }}
        >
          <Typography
            sx={{
              fontFamily: 'Schibsted Grotesk',
              fontSize: '16px',
              fontWeight: 500,
              lineHeight: '24px',
            }}
          >
            {showOriginal ? 'See less' : '... See more'}
          </Typography>
        </Button>
      )}
    </Box>
  );
};
export default Details;
